export const IMAGE_BLUR_TYPES = {
  FOREGROUND: 'FOREGROUND',
  BACKGROUND: 'BACKGROUND',
};
